/**
 * The localStorage keys the portal session lives under. One definition.
 *
 * These strings had three homes: `tokenHelper` (which reads and refreshes the
 * token), `local-storage`'s logout blocklist, and `api/portal-session` (which
 * reads the same token for the embedded surfaces). That module's own header says
 * it exists because duplicate session handling had already appeared and "the
 * refresh path is the worst place for them to drift" — while re-declaring the two
 * literals the whole thing keys on.
 *
 * The failure it invites is specific and silent: rename the key in one place and
 * the other reads `null`, which is indistinguishable from "not signed in". Every
 * /boa and audience-builder embed logs out, with nothing failing loudly.
 *
 * Deliberately a LEAF module with no imports of its own. `portal-session` cannot
 * take these from `tokenHelper`, which pulls in `jsonwebtoken` and `axios` — a
 * browser bundle has no business carrying either, and avoiding that is why
 * `portal-session` re-implemented the read in the first place.
 */
export const AUTH_TOKEN_KEY = "jwt-auth";
export const REFRESH_TOKEN_KEY = "jwt-refresh";
